import { css, Theme } from '@emotion/react'

export const title = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
`

export const tabs = css`
  margin-top: 10px;
`
